import PortfolioOutline from '@simplywallst/ui-core/icons/PortfolioOutline';

type Props = {
  label: string;
};

export const CreateNewPortfolioOption = ({ label }: Props) => (
  <div className="grid grid-cols-[36px_max-content] items-start gap-x1">
    <div className="grid min-h-9 min-w-9 items-center justify-end">
      <PortfolioOutline height="28" width="28" className="fill-chart-01" />
    </div>
    <div className="grid items-start py-x1 pr-x1">
      <p className="m-0 truncate text-xs text-legacy-spacegray">{label}</p>
    </div>
  </div>
);
